import type { ReactElement } from 'react';

export interface HighlightedLabelProps {
  /** The full label text. */
  text: string;
  /** Matched `[start,end)` to wrap in <mark>, or null for no highlight. */
  range: [number, number] | null;
}

/**
 * Renders `text`, wrapping the `range` slice in `<mark className="mp-outline__match-hit">`.
 * Shared by both outline panels (mirrors the file tree's inline highlight).
 */
export function HighlightedLabel({ text, range }: HighlightedLabelProps): ReactElement {
  if (!range) return <>{text}</>;
  const [s, e] = range;
  return (
    <>
      {text.slice(0, s)}
      <mark className="mp-outline__match-hit">{text.slice(s, e)}</mark>
      {text.slice(e)}
    </>
  );
}
